//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
import { Object } from 'leancloud-storage';

// 将整数转换成 时：分：秒的格式
function realFormatSecond (second) {
  var secondType = typeof second

  if (secondType === 'number' || secondType === 'string') {
    second = parseInt(second)

    var hours = Math.floor(second / 3600)
    second = second - hours * 3600
    var mimute = Math.floor(second / 60)
    second = second - mimute * 60

    // ${hours}

    return `${('0' + mimute).slice(-2)}'${('0' + second).slice(-2)}''` 
  } else {
    return `00'00''`
  }
}

export default {
  name: 'MusicPlayerNoAudio',
  props: {
    payload: {
      type: Object,
      default: null
    },

    track: {
      type: Object,
      default: null
    },

    index: {
      type: Number,
      default: -1
    }
  },

  data () {
    return {
      audio: {
        playing: false,
        maxTime: 0
      }
    }
  },

  computed: {
    isAudioUrlEmpty () {
      return this.track && this.track.get('audioUrl') === ""
    }
  },

  created () {
    // console.log('is paid', this.track.get('isPaid'))
    this.audio.maxTime = parseInt(this.track.get('duration'))
  },

  methods: {
    ...mapMutations(['play', 'pause', 'setCurrentAudio', 'setAudioIndex']),
    
    startPlayOrPause () {
      return this.audio.playing ? this.pause() : this.play()
    },
    control () {
      this.setCurrentAudio(this.track)
      this.setAudioIndex(this.index)
      this.play()
      

      this.$emit('click-player', this.payload)
    },

    // 当加载语音流元数据完成后，会触发该事件的回调函数
    // 语音元数据主要是语音的长度之类的数据
    // onLoadedmetadata (res) {
    //   this.audio.maxTime = parseInt(res.target.duration)
    // },
  },
  filters: {
    // 将整数转化成时分秒
    formatSecond (second = 0) {
      return realFormatSecond(second)
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/music_player/MiniPlayerNoAudio.vue